import { useEffect } from "react";
import { useNavigate } from "react-router";

const Logout = () => {

  const navigate = useNavigate();
  useEffect(() => {
    localStorage.removeItem("accessToken");
    localStorage.removeItem("refreshToken");
    //dispatch(logout())
    //dispatch(userApi.util.resetApiState());
    navigate("/login");
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <div>Logging out</div>;
};

export default Logout;
